/**
 * 把 auth-service 的 session user 收成 console 用的角色旗標。
 *
 * Worker／sg-proxy 已同時看單數 `role` 與陣列 `roles`；AuthGate 以前只看 `roles`，
 * 若回應只有 `role: "admin"`（或 roles 為空）會把管理者當聊手，帳號邀請進不去。
 */

export type SessionAuthUser = {
  readonly email: string;
  readonly roles?: readonly string[] | null;
  readonly role?: string | null;
};

export type SessionAuthState = {
  readonly email: string;
  readonly roles: readonly string[];
  readonly isAdmin: boolean;
  readonly isEngineer: boolean;
};

function pushRole(target: string[], value: unknown): void {
  if (typeof value !== 'string') return;
  const trimmed = value.trim();
  if (trimmed === '') return;
  target.push(trimmed);
}

/** 有非空 `roles` 就用它；否則退回單數 `role`。 */
export function resolveSessionRoles(user: {
  readonly roles?: readonly string[] | null;
  readonly role?: string | null;
}): string[] {
  const listed: string[] = [];
  if (Array.isArray(user.roles)) {
    for (const item of user.roles) pushRole(listed, item);
  }
  if (listed.length > 0) return listed;
  const singular: string[] = [];
  pushRole(singular, user.role);
  return singular;
}

export function authStateFromUser(user: SessionAuthUser): SessionAuthState {
  const roles = resolveSessionRoles(user);
  const lower = roles.map((role) => role.toLowerCase());
  const isAdmin = lower.includes('admin') || lower.includes('owner');
  return {
    email: user.email,
    roles,
    isAdmin,
    isEngineer: isAdmin || lower.includes('engineer'),
  };
}
